var map = {
	"./arkea.png": 1000,
	"./banque_pop.jpg": 1001,
	"./banque_postale.png": 1002,
	"./bnp.png": 1003,
	"./boursorama.png": 1004,
	"./ca.png": 1005,
	"./caisse_epargne.png": 1006,
	"./cic.jpg": 1007,
	"./credit_mutuel.jpg": 1008,
	"./hellobank.png": 1009,
	"./lcl.png": 1010,
	"./other.png": 1011,
	"./soge.png": 1012
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2867;


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/bank/square ^\.\/.*$
// module id = 2867
// module chunks = 2